// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"2800ca2a","255":"fd4f4aa5","453":"2102b1ff","495":"b057c0bc","923":"4e7c763a"}[chunkId] + ".chunk.js";
};